module.exports = __webpack_public_path__ + "img/icon_investmezzanine_process_01.6e15eb94.svg";